// @ts-nocheck
import { icon, node } from "~/util/dom";
import MapySearchOnboarding from "./onboarding";
import MapySuggest from "./suggest";
import FixedSuggest from "./fixedsuggest";
import Tooltip, { ETooltipFlow } from "~/ui/tooltip";
import { logFixedCategories } from "./fixedsuggest/analytics";
import { saveHistory } from "~/util/providers/history";
import { store } from "~/state/store";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { logClickArrowBack } from "~/search/analytics";

const EFORM_STATES = {
	DEFAULT: 0,
	SEARCH: 1,
	DETAIL: 2,
};
const TIMEOUT_FOCUS = 250;

export default class Form {
	constructor(optsArgs) {
		this._dom = {};
		this._ec = [];
		this._opts = {
			// data { query }
			onFormSend: () => {},
			onFormClear: () => {},
			// data { savedQuery, actualQuery }
			onFormCheckChange: () => {},
			// data { query, fromHistory, listCategory, noCorr }
			onFormSearch: () => {},
			// data { query, suggestData, results }
			onArrowBack: () => {},
			onSuggest: () => {},
			// data { query }
			onSuggestEnter: () => {},
			detailSuggest: false,
			// data { title, query, fromTips, cat }
			onFixedSuggestSearch: () => {},
			...optsArgs,
		};
		this._sourceInput = "keyboard";
		this._state = EFORM_STATES.DEFAULT;
		this._stateData = {
			change: false,
			searchQuery: "",
			showBackArray: false,
		};
		this._query = "";
		this._onBoarding = null;

		// vytvorime
		this._build();

		this._searchTips = new FixedSuggest({
			detailSuggest: this._opts.detailSuggest,
			// data { title, query, fromTips, cat }
			onSearch: data => {
				this._onBoarding.disable();
				// predame dal
				this._opts.onFixedSuggestSearch(data);
			},
		});
		this._searchTips.setFormNodes(this._dom.container, this._dom.input);

		// az po buildu
		this._suggest = new MapySuggest({
			input: this._dom.input,
			// data { query, suggestData, results }
			onSuggest: data => {
				// projdeme data
				const { query, suggestData } = data;

				if (!Mapy.getComponent("detail").isActive()) {
					logFixedCategories();
				}
				this._handleSuggestData(query, suggestData);

				// zavolame event dal
				this._opts.onSuggest(data);
			},
			onSuggestOpen: () => {
				this.getSearchTips().close();
				this._handleSuggestOpenClass();
			},
			onSuggestClose: () => {
				this._handleSuggestOpenClass();

				if (!this._dom.input.value.trim()) {
					this._openSearchTips();
				}
			},
			onSuggestEnter: this._opts.onSuggestEnter,
		});

		this._onBoarding = new MapySearchOnboarding(this._dom.input, CONFIG.defaultLang);

		this._searchTips.build();
		this._updateUI();
	}

	get sourceInput() {
		return this._sourceInput;
	}

	getSearchTips() {
		return this._searchTips;
	}

	getQuery() {
		return this._dom.input.value;
	}

	get width() {
		return this._dom.container.offsetWidth;
	}

	closeSuggest() {
		this._suggest.suggest.close();
	}

	sendSuggest() {
		this._suggest.suggest.send();
	}

	startOnboarding() {
		this._onBoarding.start();
	}

	endOnboarding() {
		this._onBoarding.end();
	}

	focus() {
		if (!Mapy.getComponent("layout").getWidth()) {
			return;
		}

		this._dom.input.focus();

		if (typeof this._dom.input.selectionStart === "number") {
			this._dom.input.selectionStart = this._dom.input.value.length;
			this._dom.input.selectionEnd = this._dom.input.value.length;
		} else if (typeof this._dom.input.createTextRange !== "undefined") {
			this._dom.input.focus();
			const range = this._dom.input.createTextRange();

			range.collapse(false);
			range.select();
		}
	}

	timeoutFocus(timeout = TIMEOUT_FOCUS) {
		return new Promise(resolve => {
			this._dom.input.classList.add("force-focus");

			setTimeout(() => {
				this._dom.input.classList.remove("force-focus");
				resolve();
			}, timeout);
		});
	}

	getContainer() {
		return this._dom.container;
	}

	getInput() {
		return this._dom.input;
	}

	setQuery(query) {
		this._dom.input.value = query;
		this._query = query;

		this._checkChange();
	}

	setDefaultState() {
		this._state = EFORM_STATES.DEFAULT;

		this._handleSearchTips();
		this._updateUI();
	}

	setSearchState(searchQuery) {
		this._state = EFORM_STATES.SEARCH;
		this._stateData.searchQuery = searchQuery.toLowerCase();
		this._stateData.change = false;

		this._handleSearchTips();
		this._updateUI();
	}

	setDetailState(searchQuery = "", showBackArray = false, width = 0) {
		this._state = EFORM_STATES.DETAIL;
		this._stateData.searchQuery = searchQuery.toLowerCase();
		this._stateData.change = false;
		this._stateData.showBackArray = showBackArray;

		this._dom.container.style.maxWidth = width > 0 ? `${width}px` : `100%`;

		this._handleSearchTips();
		this._updateUI();
	}

	clear() {
		this._dom.input.value = "";
		this._query = "";
		this._state = EFORM_STATES.DEFAULT;

		this._updateUI();
		this.endOnboarding();
		this._handleSearchTips();
		Mapy.getComponent("detail").clearSearch();
	}

	clearSuggestItems() {
		this._suggest.suggest.clearItems();
	}

	resetSourceInput() {
		this._sourceInput = "keyboard";
	}

	setLoading(state) {
		this._dom.container.classList[state ? "add" : "remove"]("loading");
	}

	handleEvent(event) {
		switch (event.type) {
			case "click":
				if (!this._dom.container.contains(event.target)) {
					this._closeSearchTips();
				}
				break;
			default:
		}
	}

	_build() {
		this._dom.container = node("form", { className: "search-form" });
		this._dom.input = node("input", { id: "input-search", type: "text" });
		this._dom.input.setAttribute("autocomplete", "off");
		this._dom.input.setAttribute("aria-label", _("stateSwitch.search"));

		this._dom.clearBtn = node("button", { type: "button", className: "clear-search" });

		this._dom.sendBtn = node("button", { type: "submit", className: "submit notranslate" });
		this._dom.sendBtn.setAttribute("aria-label", _("search.search"));

		this._dom.arrowBackBtn = node("button", { type: "button", className: "arrow-back-btn" });
		const leftIcon = icon("left-line-arrow");

		this._dom.arrowBackBtn.appendChild(leftIcon);
		this._tooltipBack = new Tooltip({
			anchor: leftIcon,
			trigger: this._dom.arrowBackBtn,
			content: node("p", { innerHTML: _("search.titleBack") }),
			arrow: false,
			flow: ETooltipFlow.START,
			offset: [8, 0, 8, 0],
			className: "search-form__tooltip",
			hideTimeout: 0,
		});

		JAK.DOM.append([this._dom.container, this._dom.input, this._dom.sendBtn, this._dom.arrowBackBtn, this._dom.clearBtn]);

		this._ec.push(JAK.Events.addListener(this._dom.sendBtn, "click", this, "_send"));
		this._ec.push(JAK.Events.addListener(this._dom.sendBtn, "pointerdown", this, event => {
			event.preventDefault();
		}));
		this._ec.push(JAK.Events.addListener(this._dom.arrowBackBtn, "click", this, "_clickArrowBack"));
		this._ec.push(JAK.Events.addListener(this._dom.input, "focus", this, "_focus"));
		this._ec.push(JAK.Events.addListener(this._dom.input, "keyup input", this, "_checkChange"));
		this._ec.push(JAK.Events.addListener(this._dom.input, "blur", this, "_blur"));
		this._ec.push(JAK.Events.addListener(this._dom.clearBtn, "click", this, "_clickClear"));

		if (this._opts.detailSuggest) {
			this._dom.clearBtn.appendChild(node("img", { src: "/img/loader.gif", className: "search-loader", role: "presentation" }));
		}

		this._dom.container.classList.add("detail-suggest");
		const iconContainer = node("span", { className: "clear-icon-container" });

		iconContainer.appendChild(icon("close"));
		this._dom.clearBtn.appendChild(iconContainer);
		this._dom.sendBtn.appendChild(icon("mag-glass"));

		this._tooltipClear = new Tooltip({
			anchor: iconContainer,
			trigger: this._dom.clearBtn,
			content: node("p", { innerHTML: _("search.titleClear") }),
			arrow: false,
			flow: ETooltipFlow.END,
			offset: [8, 0, 8, 0],
			className: "search-form__tooltip",
			hideTimeout: 0,
		});
	}

	_send(event) {
		JAK.Events.cancelDef(event);

		// naseptani placeholderu
		const onboardingWord = this._onBoarding.currentWord;

		if (!this._dom.input.value && onboardingWord) {
			this._dom.input.value = onboardingWord;

			this._closeSearchTips();
			// analytika
			Mapy.getComponent("logger").log("onboarding_search", {
				query: onboardingWord,
				type: 1,
			});
			// ulozime
			this._sourceInput = "onboarding";
		}

		this._onBoarding.disable();

		this._opts.onFormSend({
			query: this.getQuery(),
		});
	}

	_clickClear(event) {
		JAK.Events.cancelDef(event);
		Mapy.getComponent("search").disablePanelLoad = false;
		this.clear();
		this._opts.onFormClear();
		this._tooltipClear.hide();
	}

	_clickArrowBack(event) {
		JAK.Events.cancelDef(event);
		this._opts.onArrowBack();
		this._tooltipBack.hide();

		logClickArrowBack();
	}

	_updateUI() {
		let clearDisplay = "none";
		let sendDisplay = "none";
		const arrowBackDisplay = this._stateData.showBackArray ? "" : "none";

		switch (this._state) {
			case EFORM_STATES.DEFAULT:
				sendDisplay = "";
				clearDisplay = this._dom.input.value.trim() ? "" : "none";
				break;
			case EFORM_STATES.SEARCH:
			case EFORM_STATES.DETAIL:
				if (!this._stateData.change && this._dom.input.value.toLowerCase() !== this._stateData.searchQuery) {
					this._stateData.change = true;
				}

				if (this._stateData.change) {
					sendDisplay = "";
				} else {
					clearDisplay = "";
				}
				break;
			default:
		}

		this._dom.clearBtn.style.display = clearDisplay;
		this._dom.sendBtn.style.display = sendDisplay;
		this._dom.arrowBackBtn.style.display = arrowBackDisplay;

		this._dom.container.classList[arrowBackDisplay === "none" ? "remove" : "add"]("has-arrow-back");
	}

	_checkChange(event) {
		this._opts.onFormCheckChange({
			savedQuery: this._query,
			actualQuery: this._getQuery(),
		});

		if (this._query !== this._getQuery()) {
			this._sourceInput = event.inputType === "insertFromPaste" ? "copy_paste" : "keyboard";
		}

		this._handleSearchTips();
		this._updateUI();
	}

	_getQuery() {
		return this._dom.input.value;
	}

	_handleSearchTips() {
		this._query = this._getQuery();

		if (this._query) {
			this._closeSearchTips();
		} else {
			this._openSearchTips();
		}
	}

	_focus() {
		this._handleSearchTips();

		if (this._state === EFORM_STATES.DETAIL) {
			this._updateUI();
		}
	}

	// pouze pro detail
	_blur() {
		if (this._opts.detailSuggest) {
			this._dom.clearBtn.style.display = "";
			this._dom.sendBtn.style.display = "none";
		}

		this.timeoutFocus().then(() => {
			if (this._searchTips.isOpen() && this._opts.detailSuggest) {
				this._dom.input.classList.add("force-focus");
			}
		}, () => {});
	}

	_openSearchTips() {
		this._searchTips.open();
		this._handleSuggestOpenClass();
		this._dom.input.classList.add("force-focus");

		if (this._opts.detailSuggest) {
			document.addEventListener("click", this, true);
		}
	}

	_closeSearchTips() {
		this._searchTips.close();
		this._handleSuggestOpenClass();
		this._dom.input.classList.remove("force-focus");

		if (this._opts.detailSuggest) {
			document.removeEventListener("click", this, true);
		}
	}

	_handleSuggestData(query, suggestData) {
		const data = suggestData.data;
		const isCateogory = data.source === "poiC";

		if (isCateogory) {
			this._opts.onFormSearch({
				query,
				fromHistory: false,
				listCategory: 1,
				searchOrigin: "suggestion",
			});
		} else if (data.mmsource === "dim") {
			this._suggest.suggest.clearItems();
			Mapy.getComponent("dimcurator").setState({
				dim: data.mmid,
				search: {
					query,
					hasResults: false,
				},
			}).loadData().then(() => {
				if (["home", "work"].indexOf(data.resultType) > -1) { // pokud se jedna o domov nebo praci, nechceme ukladat dim do url
					Mapy.getComponent("dimcurator").setState();
				}
				Mapy.getComponent("history").save();
			}, () => {});
		} else if (["history_query", "query", "history_category", "category", "zero_suggest"].indexOf(data.resultType) > -1) {
			this._opts.onFormSearch({
				query,
				fromHistory: false,
				listCategory: data.resultType === "category" || data.resultType === "history_category" ? 1 : 0,
				searchOrigin: "suggestion",
			});
		} else if (["query_r", "query_top"].indexOf(data.resultType) > -1) {
			this._opts.onFormSearch({
				query,
				fromHistory: false,
				listCategory: 0,
				searchOrigin: "suggestion",
			});
		} else {
			const { user } = store.getState().user;

			if (data.source === "coor") {
				saveHistory(user, {
					title: query,
					source: "web",
					type: "query",
				}).then(() => {}, () => {});
			} else {
				saveHistory(user, {
					title: query,
					source: "web",
					type: "poi",
					data: {
						entitySource: data.source,
						entityId: data.id,
						lon: data.longitude,
						lat: data.latitude,
					},
				}).then(() => {}, () => {});
			}

			// smazeme input po prechodu na detail
			this._suggest.suggest.clearItems();
			this.clear();
			Mapy.getComponent("detail").setState({
				source: data.source,
				id: data.id,
				show: 1,
				search: {
					query,
					hasResults: false,
				},
			}).then(() => {
				Mapy.getComponent("history").save(true);
			}, () => {});

			if (Mapy.Util.isSmallResolution()) {
				Mapy.getComponent("layout").setWidth(0);
			}
		}

		if (!(suggestData.data.mmsource === "dim" && suggestData.data.resultType && ["home", "work"].indexOf(suggestData.data.resultType) > -1)) {
			Mapy.getComponent("history").save();
		}
	}

	_handleSuggestOpenClass() {
		if (this._suggest.suggest.isActive() || this._searchTips.isOpen()) {
			this._dom.container.classList.add("suggest-open");
		} else {
			this._dom.container.classList.remove("suggest-open");
		}
	}
}
